<div class="payment-selection">
  <h1 class="payment-text">
    {{ 'SETTLE_BILL.SELECT_PAYMENT_METHOD' | fallbackTranslate }}
  </h1>

  <div
    *ngIf="isFCChangePaymentMethod && !isAllfcOrderPaymentRemoved"
    class="flex-center"
  >
    <div class="custom-table flex flex_column border-radius-8 wd-85-per">
      <div class="custom-table-row flex custom-table-header fw-500 ta_left">
        <div class="custom-table-cell p-12 ta_left">
          {{ 'SETTLE_BILL.PAYMENT_METHOD' | fallbackTranslate }}
        </div>
        <div class="custom-table-cell p-12 ta_center">
          {{ 'SETTLE_BILL.AMOUNT_PAID' | fallbackTranslate }}
        </div>
        <div class="custom-table-cell p-12 ta_center">
          {{ 'SETTLE_BILL.ACTION' | fallbackTranslate }}
        </div>
      </div>
      <div
        *ngFor="
          let payment of fcOrderPayments;
          let i = index;
          trackBy: trackById
        "
      >
        <div *ngIf="!payment?.isRemoved" class="custom-table-row flex">
          <div class="custom-table-cell p-12 ta_left">
            {{
              payment?.payment_method || payment?.payment_channel | uppercase
            }}
          </div>
          <div class="custom-table-cell p-12 ta_center">
            {{ Currency }} {{ payment?.paid_total_text }}
          </div>
          <div
            (click)="removePaymentMethod(i)"
            class="custom-table-cell p-12 ta_center color-red c-pointer"
          >
            {{ 'SETTLE_BILL.DELETE' | fallbackTranslate }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <nz-spin [nzSpinning]="isLoading">
    <div class="payment-method">
      <ng-container *ngFor="let item of paymentMethod">
        <div
          class="payment-card"
          [ngClass]="{
            'payment-card-disabled not-allowed-cursor':
              (isFCChangePaymentMethod && !isAllfcOrderPaymentRemoved) ||
              isPineLabsCardDisabled(item),
            'payment-card--pine-gateway-disabled': isPineLabsCardDisabled(item),
            selected: selectedPaymentMethod === item?.id
          }"
          *ngIf="
            (item?.id === 'union_experience_voucher' && showUnionExperience) ||
            (item?.id !== 'union_experience_voucher' &&
              item.id !== this.PAYMENT_METHOD_ENUMS.doku_qris &&
              item.id !== this.PAYMENT_METHOD_ENUMS.duitnow &&
              item.id !== this.PAYMENT_METHOD_ENUMS.PINE_LABS) ||
            (item.id === this.PAYMENT_METHOD_ENUMS.doku_qris && showQris) ||
            (item.id === this.PAYMENT_METHOD_ENUMS.duitnow && showDuitnow) ||
            (item.id === this.PAYMENT_METHOD_ENUMS.PINE_LABS && showPineLab)
          "
          (click)="selectedMethod(item)"
        >
          <i
            *ngIf="isPineLabsCardDisabled(item)"
            nz-icon
            nzType="info-circle"
            nzTheme="outline"
            class="payment-pine-info-icon info"
            (click)="onPineLabsUnavailableInfoClick($event)"
          ></i>
          <img class="payment-img" src="{{ item.img_src }}" [alt]="item.name" />
          <p class="payment-title">
            {{ item.name }}
          </p>
          <img
            [src]="images.CHECKED"
            class="checkimg"
            [ngClass]="{ hidden: selectedPaymentMethod !== item.id }"
            alt="checked"
          />
        </div>
      </ng-container>
    </div>
  </nz-spin>
  <div
    class="payment-holder mt-20"
    *ngIf="show && !(isFCChangePaymentMethod && !isAllfcOrderPaymentRemoved)"
  >
    <!-- cash recommendation -->
    <div
      class="cash-collected"
      *ngIf="canCollectCash && selectedPaymentMethod == 'pos_cash'"
    >
      <div class="clr-666 fs-14 fw-700 m-b-16">
        {{ 'SETTLE_BILL.TOTAL_AMOUNT' | fallbackTranslate | titlecase }}
      </div>
      <div class="amount-tbp-div" *ngIf="balanceStatus">
        <div class="flex-row">
          <div class="flex-row-lc text-payment-tbp">
            {{
              (num > 0
                ? 'SETTLE_BILL.BALANCE_TO_BE_RETURNED'
                : 'SETTLE_BILL.COLLECT_PENDING_AMOUNT'
              )
                | fallbackTranslate
                | titlecase
            }}
          </div>
          <div class="flex-row-rc text-amount-tbp">
            {{ Currency }}
            {{ returnPositive(amountToReturn) }}
          </div>
        </div>
      </div>
      <div class="flex-row suggestion">
        <button
          *ngFor="let price of recommendationArray"
          class="amount-button"
          (click)="getButtonPrice(price)"
          [ngClass]="price == currentAmount ? 'btn-active' : null"
        >
          <p class="amount">{{ Currency }} {{ price }}</p>
        </button>
        <div
          class="select-price-container flex align_center"
          [ngClass]="customCashInput ? 'btn-active' : null"
        >
          <span> {{ Currency }} </span>
          <input
            type="string"
            min="0"
            id="origPrice"
            class="select-price-class"
            [(ngModel)]="paidAmount"
            name="origPrice"
            value=""
            placeholder="{{ 'SETTLE_BILL.ENTER_AMOUNT' | fallbackTranslate }}"
            (keyup)="valueChanges($event)"
            (keypress)="numChanges($event)"
            (click)="getButtonPrice(0, true)"
            mask="{{ inputMaskConfig?.mask }}"
            thousandSeparator="{{ inputMaskConfig?.thousandSeparator }}"
          />
        </div>
      </div>
    </div>

    <!-- transcation input -->
    <div
      class="form-container"
      *ngIf="
        !(
          selectedPaymentMethod == 'pos_cash' ||
          selectedPaymentMethod == '' ||
          selectedPaymentMethod === 'union_experience_voucher' ||
          isVoucherPlatformValid(selectedPaymentMethod)
        )
      "
    >
      <div class="text-payment-details">
        {{ 'SETTLE_BILL.AMOUNT' | fallbackTranslate }}
      </div>
      <div class="form-group form-input-container">
        <div class="form-area">
          <input
            (focus)="clearInput()"
            type="string"
            placeholder="{{ 'SETTLE_BILL.ENTER_HERE' | fallbackTranslate }}"
            [disabled]="paymentInputDisabled"
            [class.border-disable]="paymentInputDisabled"
            class="input-name-class"
            autocomplete="off"
            [(ngModel)]="paymentAmount"
            (ngModelChange)="onChangeAmount($event)"
            mask="{{ inputMaskConfig?.mask }}"
            thousandSeparator="{{ inputMaskConfig?.thousandSeparator }}"
          />
        </div>
      </div>
      <div class="text-payment-details m-t-8">
        {{ 'SETTLE_BILL.TRANSACTION_ID' | fallbackTranslate }}
      </div>
      <div class="form-group" class="form-input-container">
        <div class="form-area">
          <input
            type="text"
            placeholder="{{
              'SETTLE_BILL.ENTER_HERE_OPTIONAL' | fallbackTranslate
            }}"
            class="input-name-class"
            autocomplete="off"
            [(ngModel)]="transaction_id"
            (keypress)="changes($event)"
            (ngModelChange)="onChange($event)"
          />
        </div>
      </div>
    </div>

    <!-- Union Experience input container -->
    <div
      class="form-container"
      *ngIf="
        selectedPaymentMethod === 'union_experience_voucher' ||
        isVoucherPlatformValid(selectedPaymentMethod)
      "
    >
      <form nz-form [formGroup]="unionExperienceForm">
        <div class="form-item grid-dual-col">
          <nz-form-item>
            <div class="text-payment-details">
              {{ 'SETTLE_BILL.ENTER_AMOUNT' | fallbackTranslate }}
            </div>
            <nz-form-control
              [nzSpan]="24"
              nzErrorTip="{{ 'SETTLE_BILL.REQUIRED' | fallbackTranslate }}"
            >
              <nz-input-group [nzAddOnBefore]="Currency" nzSize="large">
                <input
                  nz-input
                  type="number"
                  min="0"
                  placeholder="0"
                  formControlName="amount"
                  onkeypress="return event.charCode >= 48"
                  name="amount"
                />
              </nz-input-group>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <div class="text-payment-details m-t-8">
              {{ 'SETTLE_BILL.ENTER_TRANSACTION_ID' | fallbackTranslate }}
            </div>
            <nz-form-control
              [nzSpan]="24"
              nzErrorTip="{{ 'SETTLE_BILL.REQUIRED' | fallbackTranslate }}"
            >
              <input
                nz-input
                nzSize="large"
                type="text"
                placeholder="XXXX"
                formControlName="txn_id"
                name="txn_id"
              />
            </nz-form-control>
          </nz-form-item>
        </div>
      </form>
    </div>

    <ng-container *ngIf="selectedPaymentMethod == ''">
      <div class="ta_center">
        <i nz-icon nzType="inbox" class="empty-icon" nzTheme="outline"></i>
        <p nz-typography nzType="secondary">
          {{ 'SETTLE_BILL.NO_PAYMENT_METHOD_SELECTED' | fallbackTranslate }}
        </p>
      </div>
    </ng-container>
  </div>
</div>
